module.exports = __webpack_public_path__ + "img/company_adress.4e24ea33.png";